import { Palette } from '@/themes/themeOverrides/Palette';

export const userContractorFieldStyles = {
    display: 'flex',
    alignItems: 'center',
    width: '352px',
    '& .MuiChip-root': {
        height: '28px',
        backgroundColor: Palette.green.green100,
        color: Palette.black,
        fontWeight: 400,
        borderRadius: '8px',
        '& .MuiChip-label': {
            fontSize: '14px',
            padding: '0 8px',
        },
    },
    '& .MuiStack-root': {
        gap: '4px !important',
    },
};

export const userFormStyles = {
    '& .MuiFormControl-root.MuiTextField-root': {
        marginTop: '0px',
        marginBottom: '9px',
    },
};

export const userInfoFieldStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    '& .user-info-field-name': {
        fontSize: '16px',
        fontWeight: 600,
        margin: '0 0 3px 0',
    },
    '& .user-info-field-phone': {
        margin: 0,
        fontSize: '11px',
    },
    '& .MuiTypography-root.MuiLink-root.user-info-field-link': {
        margin: 0,
        textDecoration: 'none',
        color: Palette.blue.blue700,
        fontSize: '11px',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    '& .user-contact-info-container': {
        margin: 0,
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
    },
};

export const userListStyles = {
    '& .MuiTableCell-root': {
        whiteSpace: 'nowrap',
    },
    '& .MuiTableCell-root.RaDatagrid-rowCell': {
        padding: '16px 24px',
    },
};

export const userDrawerStyles = {
    '& .RaShow-noActions': {
        margin: '0',
    },
    '& .popup-wrapper-top': {
        '& .popup-box--header': {
            padding: 0,
        },
    },
    '& .popup-box--header': {
        alignItems: 'center',
    },
    '& .padding-wrapper': {
        borderTop: `2px solid ${Palette.gray.gray75}`,
        padding: '40px 56px 40px',
        width: '100%',
        boxSizing: 'border-box',
    },
    '& .MuiFormHelperText-root.Mui-error': {
        color: Palette.red.red800,
        background: Palette.red.red50,
        margin: '4px 0 0',
        padding: '7px 12px',
        borderRadius: '12px',
        fontSize: '11px',
    },
    '& .MuiTypography-root.MuiTypography-h6': {
        marginBottom: '24px',
    },
    '& .MuiFormControlLabel-root': {
        marginLeft: '0px',
        '& .MuiFormControlLabel-label': {
            marginTop: '6px',
        },
    },
    '& .MuiButtonBase-root.MuiSwitch-switchBase:hover': {
        backgroundColor: 'transparent',
    },
    '& .MuiFormGroup-root': {
        '& .MuiFormHelperText-root': {
            display: 'none',
        },
    },
    '& .MuiFormGroup-root + .MuiFormGroup-root': {
        marginTop: '24px',
    },
    '& .RaEdit-noActions': {
        margin: '0 !important',
    },
    '& .create-page': {
        '& .MuiStack-root': {
            marginBottom: '0 !important',
        },
    },
};
